<div class="appContentsContainer">
  <form
    [formGroup]="fieldsAvailable"
    (ngSubmit)="onSave()"
    class="formGroup container halfForm"
  >
    <div class="pageTitle">
      {{ "royalDecree.titleAvailableFields" | translate }}
    </div>
    <div class="wrapper">
      <div class="firstPart">
        <label id="cdId" for="cdId">Identificador</label>
      </div>
      <div class="secondPart">
        <input
          type="text"
          formControlName="cdId"
          maxlength="32"
          [readonly]="operation === 'edicion'"
        />
        <div class="supIndexRequest">*</div>
      </div>
      <div class="firstPart">
        <label id="cdTexto" for="cdTexto">Texto</label>
      </div>
      <div class="secondPart">
        <input type="text" formControlName="cdTexto" maxlength="128" />
      </div>
      <div class="firstPart">
        <label id="cdAyuda" for="cdAyuda">Ayuda</label>
      </div>
      <div class="secondPart">
        <div class="dummyButtonContainerAux">
          <div class="dummyButton">
            <em class="fas fa-file-upload"></em>
          </div>
          <div class="dummyFileInputAux" style="min-height: 20px !important">
            <div
              class="dummyFileNameAux adjustText"
              style="max-height: 20px !important"
            >
              {{ fieldsAvailable.value.cdTexto }}
            </div>
          </div>
        </div>
        <input
          class="detallesEspecificosinputFile noselect otroDocumentoAdjuntar"
          type="file"
          id="documentacion"
          (change)="handleFileInput($event)"
        />
      </div>
      <div class="firstPart">
        <label id="cdTipo" for="cdTipo">Tipo de dato</label>
      </div>
      <div class="secondPart">
        <select formControlName="cdTipo" (change)="onChangeTipo()">
          <option *ngFor="let type of types" [ngValue]="type">
            {{ type }}
          </option>
        </select>
        <div class="supIndexRequest">*</div>
      </div>
    </div>

    <div
      class="wrapper"
      style="margin-top: 5px"
      *ngIf="
        !(
          fieldsAvailable.value.cdTipo == 'DBLIST' ||
          fieldsAvailable.value.cdTipo == 'BOOL' ||
          fieldsAvailable.value.cdTipo == 'LIST' ||
          fieldsAvailable.value.cdTipo == 'FILE' ||
          fieldsAvailable.value.cdTipo == 'LITERAL'
        )
      "
    >
      <div class="firstPart">
        <label id="cdLongitud" for="cdLongitud">Longitud</label>
      </div>
      <div class="secondPart">
        <input
          type="number"
          formControlName="cdLongitud"
          min="0"
          max="256"
          (change)="setNumber()"
        />
        <div class="supIndexRequest">*</div>
      </div>
    </div>

    <ng-container *ngIf="fieldsAvailable.value.cdTipo == 'DBLIST'">
      <div class="wrapper" style="margin-top: 5px">
        <div class="firstPart">
          <label id="cdListadb" for="cdListadb">Lista</label>
        </div>
        <div class="secondPart">
          <select formControlName="cdListadb">
            <option *ngFor="let list of dbLists" [ngValue]="list">
              {{ list }}
            </option>
          </select>
          <div class="supIndexRequest">*</div>
        </div>
      </div>
    </ng-container>

    <ng-container
      *ngIf="fieldsAvailable.value.cdTipo == 'LIST' && operation == 'edicion'"
    >
      <div class="wrapper" style="margin-top: 5px">
        <div class="firstPart">
          <label id="valor" for="valor">Valor a introducir</label>
        </div>
        <div class="secondPart">
          <input type="text" formControlName="valor" />
        </div>
      </div>
      <div class="w-100 margen">
        <button class="buttonLI" type="button" (click)="submitLI()">
          <em class="fas fa-plus-square"></em>
        </button>
        <button class="buttonLI" type="button" (click)="removeLI()">
          <em class="far fa-trash-alt"></em>
        </button>
      </div>
    </ng-container>

    <swal
      #confirmSwal
      html="<strong>Tienes cambios sin guardar <br/> ¿Quieres volver sin guardar?</strong>"
      icon="warning"
      [showCancelButton]="true"
      [swalOptions]="{
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        allowEscapeKey: false,
        allowOutsideClick: false
      }"
      [focusCancel]="true"
      (confirm)="goList()"
    >
    </swal>
    <div
      *ngIf="fieldsAvailable.value.cdTipo == 'LIST' && operation == 'edicion'"
    >
      <table class="margen">
        <caption style="display: none">
          Texto prueba
        </caption>
        <thead>
          <th>
            <input
              class="alingCheckbox"
              type="checkbox"
              style="cursor: pointer !important"
              [checked]="allSelected"
              (click)="selectItem('all')"
            />
          </th>
          <th>Valores de lista</th>
        </thead>
        <tbody class="filterPageTableBody">
          <ng-container *ngFor="let field of listaCampoValor">
            <tr>
              <td>
                <input
                  class="alingCheckbox"
                  type="checkbox"
                  style="cursor: pointer !important"
                  [checked]="field.checked"
                  (click)="selectItem(field)"
                />
              </td>
              <td>{{ field.valor }}</td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
    <div class="buttonsGroup">
      <div class="backButton">
        <button
          class="formButtonBack"
          type="button"
          *ngIf="!fieldsAvailable.pristine"
          [swal]="confirmSwal"
          (click)="goList()"
        >
          <em class="fas fa-caret-square-left"></em>
        </button>
        <button
          class="formButtonBack"
          type="button"
          *ngIf="fieldsAvailable.pristine"
          (click)="goList()"
        >
          <em class="fas fa-caret-square-left"></em>
        </button>
      </div>
      <div class="okButton">
        <div class="centerButton">
          <button class="formButtonOk" type="submit">
            {{ "commons.ok" | translate }}
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
